import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { HttpProvider } from '../providers/http/http';
import { BaseConfigProvider } from '../providers/base-config/base-config';
import { HomeProvider } from '../providers/home/home';
import { GroupProvider } from '../providers/group/group';
import { SendTaskProvider } from '../providers/send-task/send-task';
import { AutoProvider } from '../providers/auto/auto';
import { Keyboard } from '@ionic-native/keyboard';
import { WxProvider } from '../providers/wx/wx';
import { RealTimeProvider } from '../providers/real-time/real-time';
import { ExchangeNoticeProvider } from '../providers/exchange-notice/exchange-notice';
import { OfficialDataProvider } from '../providers/official-data/official-data';
import { BaikeProvider } from '../providers/baike/baike';
import { MyAlertProvider } from '../providers/my-alert/my-alert';
import { ComponentsModule } from '../components/components.module';
import { WalletProvider } from '../providers/wallet/wallet';
import { UtilProvider } from '../providers/util/util';
import { PhotoclipPageModule } from '../pages/photoclip/photoclip.module';
import { TextEditerPageModule } from '../pages/text-editer/text-editer.module';
import { PullDetailPageModule } from '../pages/pull/pull-detail/pull-detail.module';
import { ChatroomProvider } from '../providers/chatroom/chatroom';
import { EchartsOptionProvider } from '../providers/echarts-option/echarts-option';
import { ContactProvider } from '../providers/contact/contact';
import { CustomLoadingProvider } from '../providers/custom-loading/custom-loading';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { PullNewPageModule } from '../pages/pull/pull-new/pull-new.module';
import { SensitiveService } from '../pages/sensitive/sensitive.service';
import { SensitiveStep_1PageModule } from '../pages/sensitive/sensitive-step-1/sensitive-step-1.module';
import { SensitiveStep_2PageModule } from '../pages/sensitive/sensitive-step-2/sensitive-step-2.module';
import { NodataProvider } from '../providers/nodata/nodata';
import { ZoneProvider } from '../providers/zone/zone';
import { VideoPlayerPageModule } from '../pages/video-player/video-player.module';
import { ChooseMaterialPageModule } from '../pages/choose-material/choose-material.module';
import { MaterialProvider } from '../providers/material/material';
import { MyModalProvider } from '../providers/my-modal/my-modal';
import { SupportProvider } from '../providers/support/support';
import { LinkProvider } from '../providers/link/link';
import { RobotService } from '../pages/robot/robot.service';
import { PullProvider } from '../pages/pull/pull';
import { StaffProvider } from '../providers/staff/staff';
import { SpeakSettingProvider } from '../providers/speak-setting/speak-setting';
import { AddMemberProvider } from '../providers/add-member/add-member';
import { AddMemberPageModule } from '../pages/add-member/add-member.module';
import { AddMemberChatroomPageModule } from '../pages/add-member-chatroom/add-member-chatroom.module';
import { BacklistProvider } from '../providers/backlist/backlist';
import { AiReplayProvider } from '../providers/ai-replay/ai-replay';
import { WordProvider } from '../providers/word/word';
import { ExpandableHeaderComponent } from '../components/expandable-header/expandable-header';
import { AccountProvider } from '../providers/account/account';
import { VipIntroComponent } from '../components/vip-intro/vip-intro';
import { SignProvider } from '../providers/sign/sign';
import { EssenceProvider } from '../providers/essence/essence';
import { QrCodeProvider } from '../providers/qr-code/qr-code';
import { PermanentQrEditPageModule } from '../pages/permanent-qr/permanent-qr-edit/permanent-qr-edit.module';
import { ChooseChatroomPageModule } from '../pages/choose-chatroom/choose-chatroom.module';
import { WelcomeService } from '../pages/welcome-ver2/welcome.service';
import { PayRecordProvider } from '../providers/pay-record/pay-record';
import { EarnZidouTogetherProvider } from '../providers/earn-zidou-together/earn-zidou-together';
import { NotificationProvider } from '../providers/notification/notification';

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    ComponentsModule,
    IonicModule.forRoot(MyApp, {
      monthNames: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
      ],
      scrollAssist: false,
      autoFocusAssist: false,
      backButtonText: '返回',
      mode: 'ios',
    }),
    PhotoclipPageModule,
    TextEditerPageModule,
    PullDetailPageModule,
    PullNewPageModule,
    IonicImageViewerModule,
    SensitiveStep_1PageModule,
    SensitiveStep_2PageModule,
    VideoPlayerPageModule,
    ChooseMaterialPageModule,
    PermanentQrEditPageModule,
    ChooseChatroomPageModule,
    // AddMemberPageModule,
    // AddMemberChatroomPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp, VipIntroComponent],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    HttpProvider,
    BaseConfigProvider,
    HomeProvider,
    GroupProvider,
    SendTaskProvider,
    Keyboard,
    AutoProvider,
    WxProvider,
    RealTimeProvider,
    ExchangeNoticeProvider,
    OfficialDataProvider,
    BaikeProvider,
    MyAlertProvider,
    WalletProvider,
    UtilProvider,
    ChatroomProvider,
    EchartsOptionProvider,
    ContactProvider,
    CustomLoadingProvider,
    SensitiveService,
    NodataProvider,
    ZoneProvider,
    MaterialProvider,
    MyModalProvider,
    SupportProvider,
    LinkProvider,
    RobotService,
    PullProvider,
    StaffProvider,
    SpeakSettingProvider,
    AddMemberProvider,
    BacklistProvider,
    AiReplayProvider,
    WordProvider,
    AccountProvider,
    SignProvider,
    EssenceProvider,
    QrCodeProvider,
    WelcomeService,
    PayRecordProvider,
    EarnZidouTogetherProvider,
    NotificationProvider,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts